import { ITicketTemplateFormats } from '@core/interfaces/ticket-template/ticket-template-formats.interface';

export const TICKET_FORMATS: ITicketTemplateFormats = {
  electronic: '0ad22dc5-94a6-4c50-a5d2-0f7bfc17e133',
  sheet: 'bf83aaa5-046b-43b8-bf3b-de483436b1e5',
  pieces: 'f5daf050-707e-41d8-a679-09114fd29086',
};
